var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 224a144 144 0 10144 144 143.91 143.91 0 00-144-144zm64 150.3a9.77 9.77 0 01-9.7 9.7h-60.6a9.77 9.77 0 01-9.7-9.7v-76.6a9.77 9.77 0 019.7-9.7h12.6a9.77 9.77 0 019.7 9.7V352h38.3a9.77 9.77 0 019.7 9.7z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224 256A128 128 0 1096 128a128 128 0 00128 128zm96 112a175.38 175.38 0 0118.2-77.5 133.25 133.25 0 00-24.6-2.5h-16.7a174.08 174.08 0 01-145.8 0h-16.7A134.43 134.43 0 000 422.4V464a48 48 0 0048 48h347.1c-45.3-31.9-75.1-84.5-75.1-144z",
    className: "user-clock_svg__fa-primary"
  })));
}

export default SvgUserClock;